import { Observable, of } from "rxjs";
import { mergeMap, map, catchError } from "rxjs/operators";
import { ofType, Epic } from "redux-observable";

import { Action } from "@ctra/utils";
import { FavouritesResponse } from "./typings";

import { makeAzureApiURL } from "../../utils/ajax";
import types from "./types";
import actions from "./actions";

/**
 * Fetch favourites
 * @param action$
 * @param state$
 * @param Request
 */
const fetchFavourites: Epic = (action$, state$, { Request }) =>
  action$.pipe(
    ofType(types.FETCH_FAVOURITES.pending),
    mergeMap(() =>
      Request.GET(makeAzureApiURL("accounts", "/self/favorites/analytics")()).pipe(
        map<{ response: FavouritesResponse }, Action>(({ response }) =>
          actions.fetchFavourites.fulfill(response)
        ),
        catchError<unknown, Observable<Action>>((error) => of(actions.fetchFavourites.reject(error)))
      )
    )
  );

/**
 * Add to favourites list
 * @param action$
 * @param state$
 * @param Request
 */
const addToFavourites: Epic = (action$, state$, { Request }) =>
  action$.pipe(
    ofType(types.ADD_TO_FAVOURITES.pending),
    mergeMap<ReturnType<typeof actions.addToFavourites.start>, Observable<Promise<unknown>>>(
      ({ payload: { favourites, chart, farmID } }) =>
        Request.PUT(makeAzureApiURL("accounts", `/self/favorites/analytics?pageKey=${farmID}`)(), {
          body: favourites
        }).pipe(
          map<{ response: null }, Action>(() => actions.addToFavourites.fulfill(favourites, chart, farmID)),
          catchError<unknown, Observable<Action>>((error) => of(actions.addToFavourites.reject(error)))
        )
    )
  );

/**
 * Remove from favourites list
 * @param action$
 * @param state$
 * @param Request
 */
const removeFromFavourites: Epic = (action$, state$, { Request }) =>
  action$.pipe(
    ofType(types.REMOVE_FROM_FAVOURITES.pending),
    mergeMap<ReturnType<typeof actions.removeFromFavourites.start>, Observable<Promise<unknown>>>(
      ({ payload: { favourites, chart, farmID } }) =>
        Request.PUT(makeAzureApiURL("accounts", `/self/favorites/analytics?pageKey=${farmID}`)(), {
          body: favourites
        }).pipe(
          map<{ response: null }, Action>(() =>
            actions.removeFromFavourites.fulfill(favourites, chart, farmID)
          ),
          catchError<unknown, Observable<Action>>((error) => of(actions.removeFromFavourites.reject(error)))
        )
    )
  );

export default {
  fetchFavourites,
  addToFavourites,
  removeFromFavourites
};
